import React, { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Upload } from 'lucide-react';
export function ContactForm({
  calculatorData
}) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    jobTitle: '',
    email: '',
    phone: '',
    message: '',
    includeData: true
  });
  // Pre-populate form if we have contact info from the confirmation modal
  useEffect(() => {
    if (calculatorData?.contactInfo) {
      const {
        name,
        email,
        phone
      } = calculatorData.contactInfo;
      // Try to split name into first and last
      let firstName = name;
      let lastName = '';
      if (name && name.includes(' ')) {
        const nameParts = name.split(' ');
        firstName = nameParts[0];
        lastName = nameParts.slice(1).join(' ');
      }
      setFormData(prev => ({
        ...prev,
        firstName: firstName || '',
        lastName: lastName || '',
        email: email || '',
        phone: phone || ''
      }));
    }
  }, [calculatorData]);
  const handleChange = e => {
    const {
      id,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };
  const handleCheckboxChange = checked => {
    setFormData(prev => ({
      ...prev,
      includeData: checked
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
    // In a real implementation, you would send this data to your backend
  };
  return <div className="bg-[#4183b8] text-white rounded-lg p-8" id="contact-form" data-id="element-52">
      <h2 className="text-3xl font-bold mb-3" data-id="element-53">Want a Fully Engineered Plan?</h2>
      <p className="text-lg mb-6" data-id="element-54">
        Get a precise engineered stowage plan—reviewed by our marine logistics
        team and tailored for your job site. We'll send it over, no cost, no
        commitment.
      </p>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-55">
        <div className="grid grid-cols-2 gap-6" data-id="element-56">
          <div className="space-y-2" data-id="element-57">
            <Label htmlFor="firstName" className="text-white" data-id="element-58">
              First Name
            </Label>
            <Input id="firstName" placeholder="John" className="bg-white" required value={formData.firstName} onChange={handleChange} data-id="element-59" />
          </div>
          <div className="space-y-2" data-id="element-60">
            <Label htmlFor="lastName" className="text-white" data-id="element-61">
              Last Name
            </Label>
            <Input id="lastName" placeholder="Doe" className="bg-white" required value={formData.lastName} onChange={handleChange} data-id="element-62" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-6" data-id="element-63">
          <div className="space-y-2" data-id="element-64">
            <Label htmlFor="company" className="text-white" data-id="element-65">
              Company Name
            </Label>
            <Input id="company" placeholder="Company Ltd." className="bg-white" required value={formData.company} onChange={handleChange} data-id="element-66" />
          </div>
          <div className="space-y-2" data-id="element-67">
            <Label htmlFor="jobTitle" className="text-white" data-id="element-68">
              Job Title
            </Label>
            <Input id="jobTitle" placeholder="Project Manager" className="bg-white" required value={formData.jobTitle} onChange={handleChange} data-id="element-69" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-6" data-id="element-70">
          <div className="space-y-2" data-id="element-71">
            <Label htmlFor="email" className="text-white" data-id="element-72">
              Email
            </Label>
            <Input id="email" type="email" placeholder="john@company.com" className="bg-white" required value={formData.email} onChange={handleChange} data-id="element-73" />
          </div>
          <div className="space-y-2" data-id="element-74">
            <Label htmlFor="phone" className="text-white" data-id="element-75">
              Phone Number / WhatsApp
            </Label>
            <Input id="phone" placeholder="+1 (555) 000-0000" className="bg-white" required value={formData.phone} onChange={handleChange} data-id="element-76" />
          </div>
        </div>
        <div className="space-y-2" data-id="element-77">
          <Label htmlFor="attachments" className="text-white" data-id="element-78">
            Upload Attachments
          </Label>
          <div className="border-2 border-dashed border-white/30 rounded-lg p-4 text-center" data-id="element-79">
            <Input id="attachments" type="file" multiple className="hidden" data-id="element-80" />
            <label htmlFor="attachments" className="cursor-pointer flex flex-col items-center gap-2" data-id="element-81">
              <Upload className="h-8 w-8" data-id="element-82" />
              <span data-id="element-83">Click to upload or drag and drop files here</span>
            </label>
          </div>
        </div>
        <div className="space-y-2" data-id="element-84">
          <Label htmlFor="message" className="text-white" data-id="element-85">
            Message Description
          </Label>
          <Textarea id="message" placeholder="Please describe your requirements..." className="bg-white" rows={4} value={formData.message} onChange={handleChange} data-id="element-86" />
        </div>
        <div className="flex items-center space-x-2" data-id="element-87">
          <Checkbox id="includeData" checked={formData.includeData} onCheckedChange={handleCheckboxChange} data-id="element-88" />
          <Label htmlFor="includeData" className="text-white" data-id="element-89">
            Include calculator data with my request
          </Label>
        </div>
        <Button type="submit" className="w-full bg-[#ffd700] text-[#1a365d] hover:bg-[#ffd700]/90 text-lg font-bold" data-id="element-90">
          🎯 Yes, Send My FREE Stowage Plan
        </Button>
        <p className="text-sm text-center mt-4 text-gray-300" data-id="element-91">
          You'll get a PDF stowage layout reviewed by a SEA.O.G. engineer—ready
          to share with clients, contractors, or your project team.
        </p>
      </form>
    </div>;
}